import type { ProductCollectionSortKeys, ProductSortKeys } from "@gql/types";

export type ProductsSortOption = {
  /** URL-safe key stored in ?sort= query param */
  key: string;
  sortKey: ProductSortKeys;
  reverse: boolean;
};

export type CollectionSortOption = {
  key: string;
  sortKey: ProductCollectionSortKeys;
  reverse: boolean;
};

export const PRODUCTS_SORT_OPTIONS: Array<ProductsSortOption> = [
  {
    key: "default",
    sortKey: "BEST_SELLING",
    reverse: false,
  },
  {
    key: "best-selling",
    sortKey: "BEST_SELLING",
    reverse: false,
  },
  {
    key: "price-asc",
    sortKey: "PRICE",
    reverse: false,
  },
  {
    key: "price-desc",
    sortKey: "PRICE",
    reverse: true,
  },
  {
    key: "newest",
    sortKey: "CREATED_AT",
    reverse: true,
  },
  {
    key: "title-asc",
    sortKey: "TITLE",
    reverse: false,
  },
  {
    key: "title-desc",
    sortKey: "TITLE",
    reverse: true,
  },
];

export const COLLECTION_SORT_OPTIONS: Array<CollectionSortOption> = [
  {
    key: "default",
    sortKey: "BEST_SELLING",
    reverse: false,
  },
  {
    key: "best-selling",
    sortKey: "BEST_SELLING",
    reverse: false,
  },
  {
    key: "price-asc",
    sortKey: "PRICE",
    reverse: false,
  },
  {
    key: "price-desc",
    sortKey: "PRICE",
    reverse: true,
  },
  {
    key: "newest",
    sortKey: "CREATED",
    reverse: true,
  },
  {
    key: "title-asc",
    sortKey: "TITLE",
    reverse: false,
  },
  {
    key: "title-desc",
    sortKey: "TITLE",
    reverse: true,
  },
];

const SORT_MAP = new Map(PRODUCTS_SORT_OPTIONS.map((o) => [o.key, o]));
const DEFAULT_SORT = PRODUCTS_SORT_OPTIONS[0];

const COLLECTION_SORT_MAP = new Map(
  COLLECTION_SORT_OPTIONS.map((o) => [o.key, o]),
);
const DEFAULT_COLLECTION_SORT = COLLECTION_SORT_OPTIONS[0];

export function resolveProductsSortOption(
  key: string | null,
): ProductsSortOption {
  return (key && SORT_MAP.get(key)) || DEFAULT_SORT;
}

export function resolveCollectionSortOption(
  key: string | null,
): CollectionSortOption {
  return (key && COLLECTION_SORT_MAP.get(key)) || DEFAULT_COLLECTION_SORT;
}
